<template>
  <div>
    <button type="button" class="btn btn-theme btn-sm pull-right" @click="fn_add_express">
      <i class="fa fa-plus"></i> 增加
    </button>
    <Table size="small" :columns="columns" :data="deliveryList">
      <template slot-scope="{row,index}" slot="expresscode">
        <Select transfer v-model="deliveryList[index].expresscode">
          <Option
            :value="item.corpcode"
            :label="item.corpname"
            v-for="(item,k) in expressCorpList"
            :key="k"
          ></Option>
        </Select>
      </template>
      <template slot-scope="{row,index}" slot="expressfee">
        <InputNumber style="width:100%" v-model="deliveryList[index].expressfee"></InputNumber>
      </template>
      <template slot-scope="{row,index}" slot="remarks">
        <Input v-model="deliveryList[index].remarks"></Input>
      </template>
      <template slot="action" slot-scope="{row,index}">
        <button class="btn btn-theme" type="button" @click="fn_save_delivery(row,index)">保存</button>
        <button
          class="btn btn-danger m-l-10"
          style="padding-left:10px"
          type="button"
          @click="fn_remove_delivery(row,index)"
        >删除</button>
      </template>
    </Table>
  </div>
</template>
<script>
import { storeGoodsDeliveryType, removeGoodsDeliveryType } from "@/api/goods";
export default {
  data() {
    return {
      deliveryList: [],
      columns: [
        {
          title: "快递公司",
          slot: "expresscode",
          width: 200
        },
        {
          title: "快递费用",
          slot: "expressfee",
          width: 150
        },
        {
          title: "说明",
          slot: "remarks"
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "left"
        }
      ]
    };
  },
  watch: {
    goodsdata: {
      handler(val, old) {
        this.deliveryList = val.delivery_type;
      }
    }
  },
  methods: {
    fn_add_express() {
      let formData = {
        id: 0,
        goodsid: this.goodsdata.id,
        expresscode: "",
        expressfee: 0,
        remarks: ""
      };
      this.deliveryList.push(formData);
    },
    fn_save_delivery(row, index) {
      storeGoodsDeliveryType(row)
        .then(res => {
          if (res.data.code == 200) {
            if (row.id == 0) {
              this.deliveryList[index].id = res.data.data.id;
            }
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_remove_delivery(row, index) {
      removeGoodsDeliveryType(row.id)
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
            this.deliveryList.splice(index, 1);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
  },
  props: ["goodsdata", "expressCorpList"]
};
</script>